import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const TextDividerStyles = StyleSheet.create( {
	row: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		marginVertical: 8,
		marginHorizontal: 10,
		//height: 12
	},
	text: {
		fontSize: 12,
		color: colorList.BLACK.light,
		paddingRight: 5,
		justifyContent: 'center',
	},
	line: {
		flex: 1,
		height: 1,
		marginTop: 7.5,
		backgroundColor: colorList.GREY.dark
	}
});
